import React, { useEffect, useState } from 'react';
import Calculator from '../components/Calculator';
import DividendEstimator from '../components/DividendEstimator';
import LatestStats from '../components/LatestStats';

function Home() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main>
      {showLoader ? (
        <div className="loader-container">
          <div className="spinner"></div>
          <h1>Loading Crawford Family Bank...</h1>
        </div>
      ) : (
        <>
          <h1>Modern Banking, Timeless Trust</h1>
          <p>
            Welcome to Crawford Family Bank – proudly serving Canadian businesses with secure and private banking services.
            Explore our range of financial solutions built for your future.
          </p>
          <section>
            <h2>Financial Tools</h2>
            <div className="services">
              <Calculator />
              <DividendEstimator />
              <LatestStats />
            </div>
          </section>
        </>
      )}
    </main>
  );
}

export default Home;
